module.exports = __webpack_public_path__ + "static/media/akankshakate.a0a99455.jpg";